import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"


export default function SEO(props) {
  const { title, description, image, article, data, pathname } = props
  const siteMetadata = data && data.wagtail ? data.wagtail.metaSettings : {}

  if (!siteMetadata) {
    return (<></>)
  }

  const defaultTitle = siteMetadata.title ? siteMetadata.title : null
  const titleTemplate = title ? title : "Kelowna10 - A fresh, daily look at Kelowna news"
  const defaultDescription = siteMetadata.description ? siteMetadata.description : null
  const siteUrl = 'https://kelowna10.com/'
  const defaultImage = "https://k10media.jpbgdigital.com/kelowna10/media/images/Default_Share_Image_1.original.jpg"
  const twitterUsername = siteMetadata.twitterHandle

  let url = pathname ? siteUrl + pathname : siteUrl

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: article ? `${image}` : `${defaultImage}`,
    url: url,
  }

  const isBrowser = typeof window !== "undefined"
  if (isBrowser) {
    const b = document.documentElement;
    b.setAttribute('data-platform', navigator.platform );
  }

  const structuredDataSingle = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Kelowna10",
    "image": "https://scontent.fyyc2-1.fna.fbcdn.net/v/t39.30808-6/252831256_123699476725542_2331831098380881258_n.jpg?_nc_cat=104&ccb=1-5&_nc_sid=e3f864&_nc_ohc=WoFRDCXiEhQAX_0mnvO&_nc_ht=scontent.fyyc2-1.fna&oh=00_AT9IWHd3DcBBEk9TzgUhVNfo1B-l6DngIPHn6-P2SBsI6A&oe=61F5F1AE",
    "@id": "",
    "url": "https://kelowna10.com/",
    "telephone": "250-763-1047",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "3805 Lakeshore Road",
      "addressLocality": "Kelowna",
      "addressRegion": "AB",
      "postalCode": "V1W 3K6",
      "addressCountry": "CA"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 49.84530669999999,
      "longitude": -119.4872222
    } ,
    "sameAs": [
      "https://www.facebook.com/Kelowna10/",
      "https://www.instagram.com/kelowna10/",
      "https://twitter.com/kelownaten"
    ] 
  }

  return (
    <Helmet title={seo.title} titleTemplate={titleTemplate}>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      {!props.isApp && <meta name="apple-itunes-app" content="app-id=1590009718" />}

      {seo.url && <meta property="og:url" content={seo.url} />}

      {(article ? true : null) && <meta property="og:type" content="article" />}

      {seo.title && <meta property="og:title" content={seo.title} />}

      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}

      {seo.image && <meta property="og:image" content={seo.image} />}

      <meta name="twitter:card" content="summary_large_image" />

      {twitterUsername && (
        <meta name="twitter:creator" content={twitterUsername} />
      )}

      {seo.title && <meta name="twitter:title" content={seo.title} />}

      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}

      {seo.image && <meta name="twitter:image" content={seo.image} />}

      <meta property="al:ios" />
      {seo.url && <meta property="al:ios:url" content={seo.url} />}
      
      <meta property="al:ios:app_store_id" content="1590009718" />
      <meta property="al:ios:app_name" content="Kelowna10" />

      <meta property="al:android:package" content="com.pattison.kelowna10" />
      {seo.url && <meta property="al:android:url" content={seo.url} />}
      <meta property="al:android:app_name" content="Kelowna10" />

      <script type="application/ld+json">
        {JSON.stringify(structuredDataSingle)}
      </script>
      <link rel="preconnect" href="https://fonts.googleapis.com"></link>
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
      <link href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@800&display=swap" rel="stylesheet"></link>

      <body className="bg-midnightBlue font-body text-chalk-400" />
    </Helmet>
  )
}

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
}

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
}

